import { render, staticRenderFns } from "./_InvestorWhitelist.vue?vue&type=template&id=a23c4796&scoped=true"
import script from "./_InvestorWhitelist.vue?vue&type=script&lang=js"
export * from "./_InvestorWhitelist.vue?vue&type=script&lang=js"
import style0 from "./_InvestorWhitelist.vue?vue&type=style&index=0&id=a23c4796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23c4796",
  null
  
)

export default component.exports